import Vue from 'vue'
import Vuex from 'vuex'
import getters2 from './getters2'
import other from './modules/other'
import company from './modules/company'
Vue.use(Vuex)
export let store2 = new Vuex.Store({
  modules: {
    other,
    company,
    getters2
  },
  state: {},
  mutations: {},
  getters: {}
})



// WEBPACK FOOTER //
// ./src/store/store2.js